import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getRates = state => state.hwRates

export const selectRatesFetching = state => path(['hwRates', 'isFetching'], state)

export const selectRates = createSelector(getRates, rates => {
    if (!(isEmpty(rates.entities) || isEmpty(rates.result))) {
        const items = rates.entities.rates
        return rates.result.map(id => items[id])
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/hostelworldSelectors/hwRates.js